import React, { useEffect, useRef, useState } from "react";
import Layout from "../../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { Controller, set, useForm } from "react-hook-form";
import ToastFile from "../../../utils/ToastFile";
import {
  addTaskLog,
  getAllTaskbyContractor,
  updateTaskLog,
} from "../../../api/TaskApi";
import moment from "moment";
import {
  getAllEmployeebyContractor,
  getEmployeeDetails,
} from "../../../api/EmployeeApi";
import { getAllRoutebyContractor } from "../../../api/RouteApi";
import { TaskStatusEnum } from "../../../config/staticArray";
import ReactSelect from "react-select";
import { formatHours } from "../../../utils/utility";

const AddUpdateEmployeeTask = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isActionEdit, setIsActionEdit] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [routesOption, setRoutesOption] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [employees, setEmployees] = useState(null);
  const [routes, setRoutes] = useState(null);
  const fetched = useRef(false);
  const [isFixedPay, setIsFixedPay] = useState(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getData();
    getEmployee();
  }, []);

  const getData = async () => {
    await Promise.all([
      getAllEmployeebyContractor(user.tenant_id),
      getAllTaskbyContractor(user.tenant_id),
      getAllRoutebyContractor(user.tenant_id),
    ])
      .then(([employeeRes, taskRes, routeRes]) => {
        setEmployees(employeeRes?.data?.data?.employees);
        setRoutes(routeRes?.data?.data?.routes);
        const options = employeeRes?.data?.data?.employees.map((emp) => ({
          value: emp._id,
          label: emp.name,
        }));
        setEmployeeOptions(options);
        setTasks(taskRes?.data?.data?.tasks);
        if (state?.taskLog) {
          setIsActionEdit(true);
          const employee = employeeRes?.data?.data?.employees.find(
            (emp) => emp._id === state.taskLog.employee
          );
          let matchedRoutes = null;
          if (employee?.routesList && employee?.routesList.length > 0) {
            const routeOptions = routeRes?.data?.data?.routes
              .filter((route) => employee.routesList.includes(route._id))
              .map((route) => ({
                value: route._id,
                label: route.routeName,
              }));
            setRoutesOption(routeOptions);
            matchedRoutes = routeOptions.filter((r) =>
              state.taskLog.routeInfo?.includes(r.value)
            );
          }
          // Map employee and routes
          const matchedEmployee = options.find(
            (e) => e.value === state.taskLog.employee
          );

          //setSelectedEmployee(matchedEmployee?.value || null);

          reset({
            ...state.taskLog,
            employee: matchedEmployee,
            routeInfo: matchedRoutes,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
      });
  };

  const getRoutesbyEmployee = async (emp_id) => {
    const employee = employees.find((emp) => emp._id === emp_id);
     if (employee?.routesList && employee?.routesList.length > 0) {
            const routeOptions = routes
              .filter((route) => employee.routesList.includes(route._id))
              .map((route) => ({
                value: route._id,
                label: route.routeName,
              }));
            setRoutesOption(routeOptions);
          }
  };

  const getEmployee = async () => {
      await getEmployeeDetails(state.taskLog.employee).then((employeeRes) => {
        const employee = employeeRes?.data?.data;
        if (employee?.settings) {
          try {
            const settings =
              typeof employee.settings === "string"
                ? JSON.parse(employee.settings)
                : employee.settings;
            setIsFixedPay(
              Boolean(
                settings?.FixedPay ||
                  settings?.fixedPay ||
                  settings?.["Fixed Pay"],
              ),
            );
          } catch (e) {
            console.error("Error parsing settings:", e);
          }
        }
      });
    };

  const onSubmit = (data) => {
    let payload = {
      taskLog_id:null,
      task_id:
        tasks.find((task) => task.category === data.category)?._id || null,
      category: data.category,
      employee: data.employee?.value,
      routeInfo: data?.routeInfo.map((el) => el.value),
      date: data.date ? moment(new Date(data.date)).format("YYYY-MM-DD") : null,
      startTime: data.startTime
        ? new Date(`1970-01-01T${data.startTime}:00`)
        : null,
      endTime: data.endTime ? new Date(`1970-01-01T${data.endTime}:00`) : null,
      isApproved: "",
      tenant_id: user.tenant_id,
      status: TaskStatusEnum.COMPLETED,
      comment: data.comment || "",
      fuelCost: data.fuelCost || 0,
      actualHours: data.actualHours || 0,
      claimHours: data.claimHours || 0,
      payrate: data.payrate || 0,
      totalCost: data.totalCost || 0,
      createdBy: user.user_id,
      createdAt: new Date(),
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
    };
    if (isActionEdit) {
      payload.taskLog_id = state?.taskLog?.taskLog_id || null;
      updateTaskLog(state?.taskLog?._id, payload)
        .then((res) => {
          if (res.status === 200) {
            ToastFile("Task updated successfully", "updated");
            reset();
            navigate("/employeetasks");
          } else {
            ToastFile("Failed to update task", "error");
          }
        })
        .catch((err) => {
          console.error("Error updating task:", err);
          ToastFile("Error updating task", "error");
        });
    } else {
      addTaskLog(payload)
        .then((res) => {
          if (res.data.isSuccess) {
            ToastFile("Task added successfully", "added");
            reset();
            navigate("/employeetasks");
          } else {
            ToastFile("Failed to add task", "error");
          }
        })
        .catch((err) => {
          console.error("Error updating task:", err);
          ToastFile("Error updating task", "error");
        });
    }
  };

  const {
    register,
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const claimHours = watch("claimHours");
  const payrate = watch("payrate");
  const fuelCost = watch("fuelCost");
   const startTime = watch("startTime");
  const endTime = watch("endTime");
  const actualHours = watch("actualHours");

  useEffect(() => {
    const hours = parseFloat(claimHours) || 0;
    const rate = parseFloat(payrate) || 0;
    const fuel = parseFloat(fuelCost) || 0;

    const total = hours * rate + fuel;
    setValue("totalCost", total.toFixed(2));
  }, [claimHours, payrate, fuelCost, setValue]);

  useEffect(() => {
    if (!startTime || !endTime) return;
  
    const [startH, startM] = startTime.split(":").map(Number);
    const [endH, endM] = endTime.split(":").map(Number);
  
    const totalMinutes = (endH * 60 + endM) - (startH * 60 + startM);
    if (totalMinutes <= 0) return;
  
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    setValue("actualHours", `${hours}:${minutes}`);
  }, [startTime, endTime, setValue]);

  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
           <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
       {isActionEdit ? "Update Task" : "Add Task"}
          </span>
        </div>
        <div style={{ maxWidth: "500px" }}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Employee</Form.Label>
              <Controller
                control={control}
                name="employee"
                rules={{ required: true }}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    className="py-1 rounded-0"
                    options={employeeOptions}
                    placeholder="Search employee"
                    isDisabled={isActionEdit}
                    onChange={(selected) => {
                      field.onChange(selected); // triggers react-hook-form update
                      getRoutesbyEmployee(selected.value);
                    }}
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Task Category</Form.Label>
              <Form.Select
                {...register("category", { required: true })}
                isInvalid={errors.category}
              >
                <option value="">Select category</option>
                {tasks.map((task) => (
                  <option
                    key={task._id}
                    value={task.category}
                    selected={task.category === state?.taskLog?.category}
                  >
                    {task.category}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Route</Form.Label>
              <Controller
                control={control}
                name="routeInfo"
                rules={{ required: true }}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    isMulti
                    className="py-1 rounded-0"
                    options={routesOption}
                    onChange={(selected) => {
                      field.onChange(selected); // update form value
                    }}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                disabled={false}
                {...register("date", { required: true })}
                isInvalid={errors.date}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Start Time</Form.Label>
              <Form.Control
                type="time"
                disabled={false}
                {...register("startTime", { required: false })}
                isInvalid={errors.startTime}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>End Time</Form.Label>
              <Form.Control
                type="time"
                disabled={false}
                {...register("endTime", { required: false })}
                isInvalid={errors.endTime}
              />
            </Form.Group>
            <Form.Group className="mb-3">
                        <Form.Label>Actual working hours</Form.Label>
                        <Form.Control
                          type="text"
                          disabled={true}
                          value={formatHours(actualHours)}
                          {...register("actualHours", { required: true })}
                          isInvalid={errors.actualHours}
                        />
                      </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{isFixedPay ? "Number of Run" : "Claim Hours / No of Parcels"}</Form.Label>
              <Form.Control
                type="text"
                disabled={false}
                {...register("claimHours", { required: true })}
                isInvalid={errors.claimHours}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{isFixedPay ? "Fix Pay Rate" : "Pay Rate / Per Parcel Cost"}</Form.Label>
              <Form.Control
                type="text"
                {...register("payrate", { required: true })}
                isInvalid={errors.payrate}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Fuel Cost ($)</Form.Label>
              <Form.Control
                type="text"
                disabled={false}
                {...register("fuelCost", { required: false })}
                isInvalid={errors.fuelCost}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Total Cost ($)</Form.Label>
              <Form.Control
                type="text"
                disabled={true}
                {...register("totalCost", { required: false })}
                isInvalid={errors.totalCost}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Comment (optional)</Form.Label>
              <Form.Control
                as="textarea"
                disabled={false}
                rows={3}
                {...register("comment", { required: false })}
                isInvalid={errors.comment}
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              {isActionEdit ? "Update" : "Submit"}
            </Button>
            <Button
              variant="white"
              className="border-1 border-dark ms-2"
              onClick={() => navigate("/employeetasks")}
            >
              Cancel
            </Button>
          </Form>
        </div>
      </div>
    </Layout>
  );
};

export default AddUpdateEmployeeTask;
